import {
  addObj,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
  getMyAll,
  getMyPage,
} from '@/api/custompoiserv'

export default {
  state: {
    state_CustomPOI_AddObjResult: null,
    state_CustomPOI_GetPageResult: null,
    state_CustomPOI_GetDetailResult: null,
    state_CustomPOI_ModifyObjResult: null,
    state_CustomPOI_DeleteObjResult: null,
    state_CustomPOI_GetMyAllResult: null,
    state_CustomPOI_GetMyPageResult: null,
  },
  mutations: {
    SET_CUSTOMPOI_ADDOBJ_RESULT: (state, rst) => {
      state.state_CustomPOI_AddObjResult = rst;
    },
    SET_CUSTOMPOI_GETPAGE_RESULT: (state, rst) => {
      state.state_CustomPOI_GetPageResult = rst;
    },
    SET_CUSTOMPOI_GETDETAIL_RESULT: (state, rst) => {
      state.state_CustomPOI_GetDetailResult = rst;
    },
    SET_CUSTOMPOI_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_CustomPOI_ModifyObjResult = rst;
    },
    SET_CUSTOMPOI_DELETEOBJ_RESULT: (state, rst) => {
      state.state_CustomPOI_DeleteObjResult = rst;
    },
    SET_CUSTOMPOI_GETMYALL_RESULT: (state, rst) => {
      state.state_CustomPOI_GetMyAllResult = rst;
    },
    SET_CUSTOMPOI_GETMYPAGE_RESULT: (state, rst) => {
      state.state_CustomPOI_GetMyPageResult = rst;
    },
  },
  actions: {
    CustomPOIServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CUSTOMPOI_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CUSTOMPOI_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    CustomPOIServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CUSTOMPOI_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CUSTOMPOI_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    CustomPOIServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CUSTOMPOI_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CUSTOMPOI_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    CustomPOIServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CUSTOMPOI_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CUSTOMPOI_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    CustomPOIServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CUSTOMPOI_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CUSTOMPOI_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    CustomPOIServ_GetMyAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CUSTOMPOI_GETMYALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CUSTOMPOI_GETMYALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    CustomPOIServ_GetMyPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CUSTOMPOI_GETMYPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CUSTOMPOI_GETMYPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_CustomPOI_AddObjResult: state => {
      return state.state_CustomPOI_AddObjResult;
    },
    get_CustomPOI_GetPageResult: state => {
      return state.state_CustomPOI_GetPageResult;
    },
    get_CustomPOI_GetDetailResult: state => {
      return state.state_CustomPOI_GetDetailResult;
    },
    get_CustomPOI_ModifyObjResult: state => {
      return state.state_CustomPOI_ModifyObjResult;
    },
    get_CustomPOI_DeleteObjResult: state => {
      return state.state_CustomPOI_DeleteObjResult;
    },
    get_CustomPOI_GetMyAllResult: state => {
      return state.state_CustomPOI_GetMyAllResult;
    },
    get_CustomPOI_GetMyPageResult: state => {
      return state.state_CustomPOI_GetMyPageResult;
    },
  }
}